import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { isAnalyticsEnabled } from 'services/analytics/analyticsConfig';
import { journeySessionService } from 'services/analytics/journeySessionService';

const COMPLETED_PATHS = new Set(['/success', '/beer-store-success']);

/**
 * Tracks page views, time-on-page and session exit for journey analytics.
 * Mount once under the Router.
 */
export const useJourneyTracking = (): void => {
  const location = useLocation();
  const lastPathRef = useRef<string | null>(null);
  const analyticsEnabled = isAnalyticsEnabled();

  useEffect(() => {
    if (!analyticsEnabled) {
      return;
    }

    const path = location.pathname;
    if (lastPathRef.current === path) {
      return;
    }
    lastPathRef.current = path;

    journeySessionService.trackPageView(path, document.title);

    if (COMPLETED_PATHS.has(path)) {
      journeySessionService.markCompleted();
    }
  }, [analyticsEnabled, location.pathname]);

  useEffect(() => {
    if (!analyticsEnabled) {
      return;
    }

    const handlePageHide = () => {
      const path = window.location.pathname;
      if (COMPLETED_PATHS.has(path)) {
        journeySessionService.markCompleted();
        return;
      }
      journeySessionService.endSession('abandoned');
    };

    window.addEventListener('pagehide', handlePageHide);
    return () => {
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, [analyticsEnabled]);
};
